import * as React from 'react';
import { useQuery } from 'react-query';
import type {
  ScheduledViagensBillingReport as Report,
} from 'contracts/scheduled-reports';
import { downloadScheduledReport } from 'utils';
import { useFetchScheduledReports } from 'hooks/api/scheduled-reports';
import { Scaffold } from 'layouts';
import {
  TabbedNavigation,
} from 'pages/scheduled-reports/shared-components';
import { DataTableV2 } from 'components/ui/DataTableV2';

import { useViagensBillingReportColumns } from './hooks';

export const ViagensBillingReportsPage = () => {
  const { fetchScheduledReports } = useFetchScheduledReports<Report>();

  const columns = useViagensBillingReportColumns({
    onClickDownload: downloadScheduledReport,
  });

  const reportsQuery = useQuery({
    queryKey: ['fetch-viagens-billing-reports'],
    initialData: [],
    queryFn: () => fetchScheduledReports({
      type: 'viagens-billing',
    }),
  });

  return (
    <Scaffold>
      <TabbedNavigation />
      <div className={'flex flex-col gap-6'}>
        <DataTableV2
          columns={columns}
          data={reportsQuery?.data ?? []}
        />
      </div>
    </Scaffold>
  );
};
